export default {
  wallet: {
    title: 'वॉलेट',
    balance: 'बैलेंस',
    deposit: 'जमा',
    withdraw: 'निकासी',
    rollover: 'रोलओवर',
    transaction: 'लेनदेन',
    myBet: 'मेरा दांव',
    totalBalance: 'कुल बैलेंस',
    withdrawableBalance: 'निकासी योग्य बैलेंस',
    bonus: 'बोनस',
    bonusBalance: 'बोनस बैलेंस',
    cashBalance: 'नकद बैलेंस',
    withdrawable: 'निकासी योग्य',
    depositNow: 'अभी जमा करें',
    getBonus: 'बोनस पाएं',
    bonusGames: 'बोनस गेम',
    playNow: 'अभी खेलें',
    fiatAccount: 'फिएट खाता',
    cash: 'नकद',
    rules: 'नियम',
    ruleQ1: '1. बोनस क्या है?',
    ruleA1: 'बोनस वे पुरस्कार हैं जो प्लेटफ़ॉर्म गतिविधियों में भाग लेने के बाद देता है और इन्हें निर्धारित बोनस गेम में दांव लगाने के लिए उपयोग किया जा सकता है।',
    ruleQ2: '2. मैं बोनस का उपयोग कैसे कर सकता हूं?',
    ruleA2: 'बोनस का उपयोग दांव के लिए तभी किया जा सकता है जब नकद वॉलेट का बैलेंस समाप्त हो जाए। बोनस को नकद वॉलेट में बदलने से पहले वेजरिंग शर्त पूरी करनी होगी।',
    ruleQ3: '3. कौन से गेम बोनस दांव का समर्थन करते हैं?',
    ruleA3: 'अधिकांश स्लॉट गेम बोनस दांव का समर्थन करते हैं। गेम की विस्तृत सूची के लिए कृपया बोनस गेम पेज देखें।',
    ruleQ4: '4. बोनस को नकद वॉलेट में बदलने पर कोई प्रतिबंध हैं?',
    ruleA4: 'बोनस दांव की वेजरिंग शर्तें पूरी होने पर आप रिवॉर्ड्स सेंटर में मूल बोनस को नकद वॉलेट में बदल सकते हैं। बचा हुआ बोनस लाभ बोनस वॉलेट में लौटा दिया जाएगा और वेजरिंग शर्तें फिर से गणना की जाएंगी।',
    ruleQ5: '5. बोनस लाभ को नकद वॉलेट में बदलने पर कोई प्रतिबंध हैं?',
    ruleA5: 'बोनस लाभ को 15x वेजरिंग शर्त पूरी करनी होगी। नकद वॉलेट में बदला जा सकने वाला अधिकतम बोनस लाभ USDT5,000.00 है और प्रति दांव अधिकतम राशि USDT1,000.00 है।',
    ruleQ6: '6. वेजरिंग शर्त की गणना कैसे होती है?',
    ruleA6: 'स्लॉट गेम: दांव राशि = वेजरिंग शर्त। अन्य गेम: दांव राशि = लाभ का पूर्ण मान (दांव राशि तक)',
    select: 'चुनें',
    currency: 'मुद्रा',
    loading: 'लोड हो रहा है...',
    noMoreData: 'और डेटा नहीं',
    noData: 'कोई डेटा नहीं',
    colType: 'प्रकार',
    colTime: 'समय',
    colStatus: 'स्थिति',
    colAmount: 'राशि',
    colBalance: 'बैलेंस',
    allType: 'सभी प्रकार',
    allStats: 'सभी स्थितियां',
    colWallet: 'वॉलेट',
    colCurrent: 'वर्तमान',
    colRequired: 'आवश्यक',
    colStats: 'स्थिति',
    totalVaultBalance: 'कुल वॉल्ट बैलेंस',
    amount: 'राशि',
    availableBalance: 'उपलब्ध बैलेंस:',
    max: 'अधिकतम',
    depositInVault: 'वॉल्ट में जमा करें',
    depositCurrency: 'जमा मुद्रा',
    currencyBalance: 'मुद्रा बैलेंस',
    history: 'इतिहास',
    vaultRules: 'वॉल्ट नियम',
    vaultRule1: 'वॉल्ट धन को सुरक्षित रखने की एक सुरक्षित जगह है, जहां लेनदेन शुल्क या ब्लॉकचेन की देरी की चिंता नहीं। वॉल्ट आपके अपने डिजिटल वॉलेट या बैंक के बचत खाते की तरह काम करता है। 2FA की बदौलत यह बेहद सुरक्षित है, और आप भीतर के धन की रक्षा के लिए अतिरिक्त सुरक्षा उपाय लागू कर सकते हैं।',
    vaultRule2: 'वॉल्ट में धन की जमा और निकासी 2FA द्वारा सुरक्षित है और जमाकर्ता इसे किसी भी समय एक्सेस कर सकता है।',
    vaultRule3: 'वॉल्ट में मौजूद धन को जमाकर्ता के अलावा कोई नहीं छू सकता। यह आपका है और हमेशा आपके उपयोग के लिए सुरक्षित रहेगा!',
    selectTime: 'समय चुनें',
    colGame: 'गेम',
    colBet: 'दांव',
    colWin: 'जीत',
    colProfit: 'लाभ',
    sports: 'खेल',
    allGames: 'सभी गेम',
    today: 'आज',
    yesterday: 'कल',
    last3Days: 'पिछले 3 दिन',
    last7Days: 'पिछले 7 दिन',
    last15Days: 'पिछले 15 दिन',
    last30Days: 'पिछले 30 दिन',
  },
};
